var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-block schedule-print-button",attrs:{"disabled":_vm.isLoading,"title":"Download schedule as PDF"},on:{"click":_vm.doClick}},[_c('CloudArrowDownFill',{staticClass:"icon-default"}),_c('span',[_vm._t("default",function(){return [_vm._v("PDF")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }